/**
 * Spaces API contracts
 *
 * Unified self-listing endpoint (GET /v1/spaces) + single-space read
 * (GET /v1/spaces/:spaceId).
 */

export * from './common'
export * from './list'
export * from './detail'
export * from './preferences'
export * from './settings-update'
export * from './settings-write'
